import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { Sort } from '@angular/material/sort';
// import { DialogService } from 'app/shared/services/dialog/dialog.service';
// import { IConfirmationDialogOptions } from 'app/shared/services/dialog/confirmation-dialog/confirmation-dialog-options.interface';
import * as _ from 'lodash';
import { Router } from '@angular/router';
import { ICurrency } from './currencies.interface';
import { CurrenciesService } from './currencies.service';
import { CurrenciesModalComponent } from './currencies-modal/currencies-modal.component';
// import { IInformationDialogOptions } from 'app/shared/services/dialog/information-dialog/information-dialog-options.interface';
import { CurrencyAlignment } from './currencies.constants';
import { IFilter } from '../../../shared/interfaces/filter.interface';
import { Broadcaster } from '../../../shared/components/broadcaster.component';
import { AuthService } from '../../../shared/services/auth.service';
import { DialogService } from '../../../shared/services/dialog/dialog.service';
import { IConfirmationDialogOptions } from '../../../shared/services/dialog/confirmation-dialog/confirmation-dialog-options.interface';
import { IInformationDialogOptions } from '../../../shared/services/dialog/information-dialog/information-dialog-options.interface';

let self: any;

@Component({
  selector: 'app-currencies',
  templateUrl: './currencies.component.html',
  styleUrls: ['./currencies.component.css']
})
export class CurrenciesComponent implements OnInit {
  currencies: ICurrency[] = [];
  loading: boolean = false;
  thereAreMore: boolean = false;
  filter: IFilter = {
    sort: '',
    skip: 0,
    limit: 20
  };
  filtered = false;
  scrollSubscription!: Subscription;
  sortOptions: any = {
    "name": 'Nombre asc',
    "-name": 'Nombre desc',
  };
  sortOptionsKeys = Object.keys(this.sortOptions);
  selection: any = { all: false };
  isDev: any;
  CurrencyAlignment: any = CurrencyAlignment;
  CurrencyAlignmentKeys = Object.keys(CurrencyAlignment);

  constructor(
    private _CurrencyService: CurrenciesService,
    private _broadcaster: Broadcaster,
    private _dialogService: DialogService,
    private _dialog: MatDialog,
    private _viewContainerRef: ViewContainerRef,
    private router: Router,
    private _AuthService: AuthService
  ) {
    self = this;
    this.registerStringBroadcast();
  }

  ngOnInit() {
    this.isDev = this._AuthService.isRole('dev');
    this.getCurrencies(true);
  }

  getCurrencies(reset?: boolean) {
    this.loading = true;
    this.thereAreMore = false;
    if (reset) {
      window.scroll(0, 0);
      this.filter.skip = 0;
      this.currencies = [];
      this.clearSelection();
    }
    this._CurrencyService.getCurrencies(this.filter).subscribe((currencies: any) => {
      this.currencies = _.concat(this.currencies, currencies);
      const filter: any = this.filter;
      this.thereAreMore = currencies.length >= filter.limit;
      this.loading = false;
    })
  }

  loadMore() {
    if (this.thereAreMore && !this.loading) {
      const filter: any = this.filter;
      filter.skip += filter.limit;
      this.getCurrencies();
    }
  }

  registerStringBroadcast() {
    this.scrollSubscription = this._broadcaster.on<string>('FinishScrollDown')
      .subscribe(() => {
        this.loadMore();
      });
  }

  ngOnDestroy() {
    this.scrollSubscription.unsubscribe();
  }

  sortCurrencies(sort: any) {
    this.filter.sort = (typeof sort == 'string') ? sort : ((sort.direction == 'asc') ? '' : '-') + sort.active;
    this.getCurrencies(true);
  }

  openFilter() {
    console.log('openFilter');
  }

  openNewCurrencyModal() {
    this.openCurrencyModal({});
  }

  openCurrencyModal(currency: ICurrency, readOnly: boolean = false) {
    let config = new MatDialogConfig();
    // config.disableClose = true;
    config.width = '400px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.dialogRef = this._dialog.open(CurrenciesModalComponent, config);
    self.dialogRef.componentInstance.currency = currency;
    self.dialogRef.componentInstance.readOnly = readOnly;

    self.dialogRef.afterClosed().subscribe((result: any) => {
      self.dialogRef = null;
      if (result) this.getCurrencies(true);
    });
  }

  openDeleteCurrencyConfirm(currency: ICurrency, hardDelete: boolean = false) {
    const modalOptions: IConfirmationDialogOptions = {
      title: "Eliminar Moneda",
      message: "Esta seguro que desea eliminar '" + currency.name + "'?",
      yesButtonLabel: 'Aceptar', noButtonLabel: 'Cancelar'
    };
    this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef)
      .subscribe((confirmation: any) => {
        if (confirmation) {
          this._CurrencyService.deleteCurrency(currency, hardDelete).subscribe(() => {
            if (hardDelete) this.getCurrencies(true);
            else currency.isDeleted = true;
          })
        }
      });
  }

  openRestoreCurrencyConfirm(currency: ICurrency) {
    const modalOptions: IConfirmationDialogOptions = {
      title: "Restaurar Moneda",
      message: "Esta seguro que desea restaurar '" + currency.name + "'?",
      yesButtonLabel: 'Aceptar', noButtonLabel: 'Cancelar'
    };
    this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef)
      .subscribe((confirmation: any) => {
        if (confirmation) {
          this._CurrencyService.restoreCurrency(currency).subscribe(() => {
            currency.isDeleted = false;
          })
        }
      });
  }

  openExportItems(all: boolean) {
    this.openUnderConstructionDialog();
  }

  openUnderConstructionDialog() {
    const modalOptions: IInformationDialogOptions = {
      title: "¡Próximamente!",
      message: "Esta funcionalidad se encuentra en construcción.",
      closeButtonLabel: "Ok"
    };
    this._dialogService.openInformationModal(modalOptions, this._viewContainerRef)
      .subscribe(() => {
        console.log('ok')
      });
  }

  clearSelection() {
    this.selection = { all: false }
  }

  checkSomeSelected() {
    this.selection.some = Object.keys(this.selection)
      .filter(el => el !== 'all' && el !== 'some')
      .filter(el => this.selection[el])
      .length > 0;
  }
  
  toggleSelection(_id?: string) {
    if (_id) {
      // Modificar la selección de un elemento individual
      this.selection[_id] = !this.selection[_id];

      // Verificar si todos los elementos están seleccionados
      const allSelected = this.currencies.every(currency => {
        const id = currency?._id || '';
        return this.selection[id];
      });

      // Actualizar "seleccionar todos" en base a los elementos seleccionados
      this.selection.all = allSelected;
    } else {
      // Seleccionar o deseleccionar todos
      const newValue = !this.selection.all;
      this.selection = { all: newValue };

      // Aplicar el nuevo estado a todos los elementos
      this.currencies.forEach(currency => {
        const id = currency?._id || '';
        this.selection[id] = newValue;
      });
    }

    // Actualizar si hay alguna selección
    this.checkSomeSelected();
  }
}